import { render, staticRenderFns } from "./league.vue?vue&type=template&id=799e053a&scoped=true&"
import script from "./league.vue?vue&type=script&lang=ts&"
export * from "./league.vue?vue&type=script&lang=ts&"
import style0 from "./league.vue?vue&type=style&index=0&id=799e053a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e053a",
  null
  
)

export default component.exports